<script setup>
import { useAgendaNotifications } from '../composables/useAgendaNotifications';

const { notifications, dismissNotification } = useAgendaNotifications();

function formatTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
</script>

<template>
  <Teleport to="body">
    <TransitionGroup
      name="agenda-notif"
      tag="div"
      class="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none"
    >
      <div
        v-for="notif in notifications"
        :key="notif.id"
        class="pointer-events-auto w-80 rounded-xl border border-n-weak bg-n-solid-2 shadow-xl overflow-hidden"
      >
        <div class="flex items-center gap-2 px-4 py-2 bg-n-blue-3 border-b border-n-weak">
          <span class="i-lucide-bell-ring w-4 h-4 text-n-blue-11" />
          <span class="text-xs font-semibold text-n-blue-11 flex-1">
            Agenda — em {{ notif.windowLabel }}
          </span>
          <button
            class="text-n-slate-10 hover:text-n-slate-12 transition-colors"
            @click="dismissNotification(notif.id)"
          >
            <span class="i-lucide-x w-3.5 h-3.5" />
          </button>
        </div>
        <div class="px-4 py-3">
          <p class="text-sm font-semibold text-n-slate-12 truncate">
            {{ notif.title }}
          </p>
          <div class="flex items-center gap-1.5 mt-1.5">
            <span class="i-lucide-clock w-3.5 h-3.5 text-n-slate-10" />
            <span class="text-xs text-n-slate-11">
              {{ formatTime(notif.startsAt) }}
            </span>
          </div>
          <div
            v-if="notif.location"
            class="flex items-center gap-1.5 mt-1"
          >
            <span class="i-lucide-map-pin w-3.5 h-3.5 text-n-slate-10" />
            <span class="text-xs text-n-slate-11 truncate">
              {{ notif.location }}
            </span>
          </div>
          <div
            v-if="notif.contactName"
            class="flex items-center gap-1.5 mt-1"
          >
            <span class="i-lucide-user w-3.5 h-3.5 text-n-slate-10" />
            <span class="text-xs text-n-slate-11 truncate">
              {{ notif.contactName }}
            </span>
          </div>
        </div>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<style>
.agenda-notif-enter-active {
  transition: all 0.3s ease-out;
}
.agenda-notif-leave-active {
  transition: all 0.2s ease-in;
}
.agenda-notif-enter-from {
  opacity: 0;
  transform: translateX(100px);
}
.agenda-notif-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
